import React from "react";

export default props => (
    <input type="hidden" name={ props.name } id={ props.name } value={ props.value } />
);
